export enum NodeType {
  project = 'PROJECT',
  cloudAccount = 'CLOUD_ACCOUNT'
}
